import { ChevronDown } from "lucide-react";
import { MouseEventHandler, ReactNode } from "react";

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
};

export const DropdownButton = ({ children, onClick }: Props) => {
  return (
    <button
      type="button"
      className="p-4 pr-2 border border-sleap-gray-400 rounded-lg w-full md:w-auto md:px-2 md:py-1 md:border-none text-base font-inter flex gap-1 text-sleap-gray-700 dark:text-white"
      onClick={onClick}
    >
      {children}
      <ChevronDown />
    </button>
  );
};
